const creations = (state = [], action) => {
  switch (action.type) {
    case 'SET_CREATIONS':
      return action.creations
    default:
      return state
  }
}

export default creations
